<script lang="ts">
const __DsBlock = {
	type: 'input',
	icon: 'lucide:palette',
	name: '$t:blocks.input_color.name',
	description: '$t:blocks.input_color.description',
	category: 'input',
	fieldBinding: { supportedTypes: ['color'] },

	options: [
		{
			name: 'modelValue',
			label: '$t:blocks.common.props.value',
			model: true,
		},
		{
			name: 'variant',
			label: '$t:blocks.common.props.variant',
			type: 'enum',
			values: BLOCK_INPUT_VARIANT_OPTIONS,
		},
		{
			name: 'size',
			label: '$t:blocks.common.props.size',
			type: 'enum',
			values: BLOCK_CONTROL_SIZE_OPTIONS,
		},
		{
			name: 'placeholder',
			label: '$t:blocks.common.props.placeholder',
		},
		{
			name: 'disabled',
			label: '$t:blocks.common.props.disabled',
		},
		{
			name: 'readonly',
			label: '$t:blocks.common.props.readonly',
		},
		{
			name: 'disabledNotice',
			label: '$t:blocks.common.props.disabled_notice',
		},
	],
}
</script>
<script lang="ts" setup>
import type { InputBlockProps } from '#layers/blocks/types/input-block';
import type { InputColorProps } from '#layers/ui/public';
import { computed } from 'vue';
import { defineBlock } from '#layers/block-engine/public';
import { BLOCK_CONTROL_SIZE_OPTIONS, BLOCK_INPUT_VARIANT_OPTIONS } from '#layers/blocks/constants/ui-options';
import { usePrimitiveFormField } from '#layers/forms/public';
import { useDisabledNotice } from '#layers/ui/public';

interface Props extends
	InputBlockProps,
	Pick<InputColorProps, 'variant' | 'size' | 'placeholder'> {
}

const {
	disabled: disabledProp,
	disabledNotice: disabledNoticeProp,
	variant,
	size,
	placeholder,
	readonly,
} = defineProps<Props>();
const forwarded = computed(() => ({ variant, size, placeholder, readonly }));

;

const model = defineModel<string | null>();
const { modelValue, disabled, disabledNotice, nullable } = usePrimitiveFormField(() => ({ disabled: disabledProp, disabledNotice: disabledNoticeProp }), { model });
const { showDisabledNotice } = useDisabledNotice({ disabled, disabledNotice });
</script>

<template>
	<DTooltip :delay-duration="0" :disabled="!showDisabledNotice" :text="disabledNotice">
		<!-- TODO: <div> necessary because DTooltip doesn't play nice with DInputColor (tooltip doesn't show up) -->
		<div>
			<DInputColor
				v-bind="forwarded"
				v-model="modelValue"
				:disabled
				:aria-readonly="readonly"
				:clear="nullable"
				block
			/>
		</div>
	</DTooltip>
</template>
